<template>
  <div id="CarbonAccounting">
    <SectionHeader />
    <SectionTrust />
    <SectionImpact />
    <SectionGHGDemo />
    <SectionManufacturingCompliance />
    <SectionCompliance />
    <SectionDeliverResults />
    <SectionReviews />
    <SectionFutureproof />
    <SectionGovernance />
    <SectionSupplierScope3 />
    <SectionReportingCompliance />
    <SectionTrackRecord />
    <SectionPlanCompare />
    <SectionLeaveSpreadsheet />
    <SectionCarbonAccountingFAQs />
  </div>
</template>

<script setup lang="ts">
import SectionTrust from '@/views/components/sections/SectionTrust.vue'
import SectionHeader from './sections/SectionHeader.vue'
import SectionImpact from './sections/SectionImpact.vue'
import SectionManufacturingCompliance from './sections/SectionManufacturingCompliance.vue'
import SectionCompliance from '@/views/components/sections/SectionCompliance.vue'
import SectionDeliverResults from './sections/SectionDeliverResults.vue'
import SectionReviews from '@/views/components/sections/SectionReviews.vue'
import SectionFutureproof from './sections/SectionFutureproof.vue'
import SectionSupplierScope3 from './sections/SectionSupplierScope3.vue'
import SectionGovernance from './sections/SectionGovernance.vue'
import SectionReportingCompliance from './sections/SectionReportingCompliance.vue'
import SectionPlanCompare from './sections/SectionPlanCompare.vue'
import { useSeo, getBreadcrumbStructuredData } from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'
import SectionGHGDemo from '@/views/components/sections/SectionGHGDemo.vue'
import SectionTrackRecord from './sections/SectionTrackRecord.vue'
import { useHead } from '@vueuse/head'
import SectionLeaveSpreadsheet from './sections/SectionLeaveSpreadsheet.vue'
import SectionCarbonAccountingFAQs from './sections/SectionCarbonAccountingFAQs.vue'

// Preload critical hero image for this page
useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/src/views/pages/CarbonAccounting/assets/header/hero.avif',
      fetchpriority: 'high',
      type: 'image/avif',
    },
  ],
})

// SEO Configuration
useSeo(
  getSeoConfig('carbonAccounting'),
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    {
      name: 'Carbon Accounting',
      url: 'https://sustainalyse.com/carbon-accounting',
    },
  ]),
)
</script>

<style lang="scss" scoped>
#PageGhgCalculator {
  min-height: 100vh;
}
</style>
